import { Select } from '@tkww/orion-web-ds-input';
import { GridColumn, GridRow } from '@tkww/orion-web-ds-structure';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { sortByFeatured } from '../../../../../utils/featuredCategoryCodes';
import Styles from './styles.scss';

export default class Category extends PureComponent {
	static propTypes = {
		categories: PropTypes.array.isRequired,
		category: PropTypes.object.isRequired,
		setCategory: PropTypes.func.isRequired,
	};

	setCategory = (event) => {
		const matchingCategory = this.props.categories.filter(
			(cat) => cat.id === event.detail.value,
		)[0];
		this.props.setCategory(matchingCategory);
	};

	render() {
		const options = sortByFeatured(this.props.categories).map((category) => ({
			text: category.name,
			value: category.id,
		}));

		return (
			<GridRow>
				<GridColumn md="6" lg="6" className={Styles.categorySelect}>
					<Select
						onSelectedChange={this.setCategory}
						name="Select a Vendor Category"
						selected={this.props.category.id}
						options={options}
					/>
				</GridColumn>
			</GridRow>
		);
	}
}
